import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isToday from 'dayjs/plugin/isToday'
import calendar from 'dayjs/plugin/calendar'
import updateLocale from 'dayjs/plugin/updateLocale'
import 'dayjs/locale/tr'

dayjs.extend(customParseFormat)
dayjs.extend(isToday)
dayjs.extend(calendar)
dayjs.locale('tr')
dayjs.extend(updateLocale)
dayjs.updateLocale('tr', {
  calendar: {
    lastDay: '[Dün] - DD MMMM YYYY dddd',
    lastWeek: '[Geçen Hafta] - DD MMMM YYYY dddd',
    nextDay: '[Yarın] - DD MMMM YYYY dddd',
    nextWeek: '[Gelecek Hafta] - DD MMMM YYYY dddd',
    sameDay: '[Bugün] - DD MMMM YYYY dddd',
    sameElse: 'DD MMMM YYYY dddd',
  },
})

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

dayjs.tz.setDefault('Europe/Istanbul')

const amyDayjs = dayjs

export default amyDayjs
